<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="pageTitle" :icon="pageIcon"/>
        <app-tab :tabs="tabs" :icon="pageIcon"/>
    </div>
</template>

<script>
    export default {
        name: "SettingsLayout",
        props: {
            permissions: {}
        },
        data() {
            return {
                pageTitle: 'Settings',
                pageIcon: 'settings',
                tabs: [
                    {
                        "name": this.$t('general'),
                        "title": this.$t('general'),
                        "component": "general-setting",
                        "permission": this.permissions.general,
                    },
                    {
                        "name": this.$t('email_setup'),
                        "title": this.$t('email_setup'),
                        "component": "email-setting",
                        "permission": this.permissions.email_settings,
                    },

                    {
                        "name": this.$t('costs'),
                        "title": this.$t('costs'),
                        "component": "costs-setting",
                        "permission": this.permissions.general,
                    },

                    {
                        "name": this.$t('contracts'),
                        "title": this.$t('contracts'),
                        "component": "contract-setting",
                        "permission": this.permissions.general,
                    },

                    {
                        "name": this.$t('units'),
                        "title": this.$t('units'),
                        "component": "unit-setting",
                        "permission": this.permissions.general,
                    },

                    {
                        "name": this.$t('currency'),
                        "title": this.$t('currency'),
                        "component": "currency-setting",
                        "permission": this.permissions.general,
                    },

                    {
                        "name": this.$t('notification'),
                        "title": this.$t('notification'),
                        "component": "notification-settings",
                        "permission": this.permissions.notification,
                    },
                    {
                        headerButton: {
                            label: this.$t('add_custom_table'),
                            class: 'btn btn-primary'
                        },
                        'name': this.$t('custom_table'),
                        'title': this.$t('custom_table'),
                        'component': 'app-custom-tables',
                        'permission': true,
                    },
                ]
            }
        },
    }
</script>
